import React, { Component } from 'react'

import Bugsnag from '~/scenes/bugsnag'

export default class AdminField extends Component {
  constructor (props) {
    super(props)
    this.state = { hasCrashed: false }
  }

  shouldComponentUpdate (nextProps, nextState) {
    return (
      this.props.name !== nextProps.name ||
      this.props.label !== nextProps.label ||
      this.props.values[this.props.name] !== nextProps.values[nextProps.name] ||
      this.props.errors[this.props.name] !== nextProps.errors[nextProps.name] ||
      this.props.size !== nextProps.size ||
      this.props.onlyField !== nextProps.onlyField ||
      this.props.errorHTML !== nextProps.errorHTML ||
      this.props.children !== nextProps.children ||
      this.state.hasCrashed !== nextState.hasCrashed
    )
  }

  setTargetValue = e => {
    const { setValue } = this.actions
    const { name } = this.props

    setValue(name, e.target.value)
  }

  setValue = value => {
    const { setValue } = this.actions
    const { name } = this.props

    setValue(name, value)
  }

  componentDidCatch (error, info) {
    this.setState({ hasCrashed: true })
    Bugsnag.notify(error)
  }

  render () {
    const { hasCrashed } = this.state
    const {
      errors,
      values,
      name,
      label,
      children,
      errorHTML,
      size = 'short',
      onlyField = false,
      displayError = true,
      dataAttr
    } = this.props

    if (hasCrashed) {
      return (
        <div className='simple-error' style={{ marginBottom: 20, padding: 10, border: '1px solid red' }}>
          Error! Something went wrong with this part of the page!
        </div>
      )
    }

    const field = children({
      value: values[name],
      setTargetValue: this.setTargetValue,
      setValue: this.setValue
    })

    if (onlyField) {
      return field
    }

    return (
      <li
        className={`string input optional stringish ${size} ${errors[name] ? 'has-errors' : ''}`}
        data-attr={dataAttr}
      >
        <label className='block'>{label || <span style={{ display: 'inline-block' }} />}</label>
        {field}
        {errors[name] && errorHTML && displayError && (
          <p className='inline-hints' style={{ color: 'red' }} dangerouslySetInnerHTML={{ __html: errors[name] }} />
        )}
        {errors[name] && !errorHTML && displayError && (
          <p className='inline-hints' style={{ color: 'red' }}>
            {errors[name]}
          </p>
        )}
      </li>
    )
  }
}
